import store from '../index';
import { sendPost } from '../../utils/request';
import * as type from '../constants/ActionTypes';

// 检查是否登录
export const checkLoginRequest = (data) => (
  sendPost('/user/checkLogin', data, true).then((res) => {
    if (res && res.code === type.OK) {
      store.dispatch({ payload: res, type: type.CHECKLOGIN });
    }
    window.loginUrl = res.loginUrl
    return res;
  })
);

// 清除cookie并重写
export const ClearCookieOverride = (data) => (
  sendPost('/user/cookie/override', data).then((res) => {
    if (res && res.code === type.OK) {
      store.dispatch({ payload: res, type: type.CHECKLOGIN });
    }
    return res;
  })
);
